import React from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";

const h4 = {
	fontFamily: '"Poppins", sans-serif',
	fontSize: 13,
	fontWeight: 600,
	margin: "6px 0 4px",
	textAlign: "center",
};

// Template93: Tiendas NY (guia-ny Shops). Contenido desde page (texts, shops, images).
const Template93 = ({
	backgroundColor,
	textColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
	updatePage,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const contentColor = textColor || "#444";
	const p = {
		fontFamily: (fontFamily || '"Poppins", sans-serif') + " !important",
		fontSize: 13,
		color: contentColor,
		margin: 0,
	};

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found && found.src) return found.src;
		}
		return undefined;
	};

	const headerText =
		page?.texts?.[0]?.content ?? "Tiendas originales en Nueva York";
	const introText = page?.texts?.[1]?.content;
	const closingText = page?.texts?.[2]?.content;
	const shops =
		Array.isArray(page?.shops)
			? page.shops
			: Array.isArray(page?.data?.shops)
			? page.data.shops
			: Array.isArray(page?.data?.data?.shops)
			? page.data.data.shops
			: [];
	const sticker1 = getImageSrc("m&m-stickers") || getImageSrc("shops-sticker1");
	const sticker2 = getImageSrc("fao-stickers") || getImageSrc("shops-sticker2");
	const sticker3 = getImageSrc("nba-sticker") || getImageSrc("shops-sticker3");

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				height: "auto",
				backgroundColor: backgroundColor || "#f7f7f7",
				color: contentColor,
				fontFamily: fontFamily || '"Poppins", sans-serif',
				"& *:not([data-template-header])": {
					fontFamily: (fontFamily || '"Poppins", sans-serif') + " !important",
					color: "inherit",
				},
			}}
		>
			<div
				data-block-id="header"
				style={{
					backgroundColor: headerBackgroundColor || "#59c3d8",
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 700,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1053,
				}}
			>
				{headerText}
			</div>
			{introText && (
				<div data-block-id="text-1" style={{ padding: "16px 16px", fontSize: 13, color: contentColor }}>
					<p style={p}>{introText}</p>
				</div>
			)}
			<div
				data-block-id="text-2"
				style={{
					padding: "0 12px 12px",
					display: "flex",
					flexWrap: "wrap",
					gap: 8,
					position: "relative",
					justifyContent: "center",
				}}
			>
				{shops.map((shop) => {
					const src = getImageSrc(shop.imageId);
					return (
						<div
							key={shop.name}
							style={{
								backgroundColor: "#fff",
								borderRadius: 12,
								width: isSmallScreen ? "30%" : "20%",
								padding: 8,
								display: "flex",
								flexDirection: "column",
								alignItems: "flex-start",
							}}
						>
							{src && (
								<img
									src={src}
									alt={shop.name}
									style={{
										width: "100%",
										height: 70,
										objectFit: "cover",
										borderRadius: 8,
									}}
								/>
							)}
							<h4 style={{ ...h4, textAlign: "left" }}>{shop.name}</h4>
							<p style={{ ...p, textAlign: "left" }}>{shop.address}</p>
						</div>
					);
				})}
				{sticker1 && (
					<img
						src={sticker1}
						alt=""
						style={{ width: 90, position: "absolute", top: -40, right: -9 }}
					/>
				)}
				{sticker2 && (
					<img
						src={sticker2}
						alt=""
						style={{
							width: 110,
							position: "absolute",
							bottom: isSmallScreen ? -90 : -20,
							left: -20,
						}}
					/>
				)}
				{sticker3 && (
					<img
						src={sticker3}
						alt=""
						style={{
							width: 100,
							position: "absolute",
							bottom: isSmallScreen ? -90 : -20,
							right: -21,
						}}
					/>
				)}
			</div>
			{closingText && (
				<div
					data-block-id="text-3"
					style={{
						padding: "0 16px 20px",
						paddingBottom: 0,
						textAlign: "center",
						display: "flex",
						justifyContent: "center",
						alignItems: "center",
					}}
				>
					<p
						style={{
							fontFamily: (fontFamily || '"Poppins", sans-serif') + " !important",
							fontSize: 13,
							color: contentColor,
							margin: 0,
							maxWidth: isSmallScreen ? 200 : 380,
						}}
					>
						{closingText}
					</p>
				</div>
			)}
		</Box>
	);
};

export default Template93;
